import logo from 'assets/logo-header.png';
import { Container, Navbar } from 'react-bootstrap';
import { GoLock } from 'react-icons/go';
import { Link } from 'react-router-dom';
import styles from 'styles/styles.module.css';

export default function CustomNavbar() {
  return (
    <Navbar bg="white" expand="lg" className="border-bottom">
      <Container className="px-3 px-md-4 py-0">
        <div className="d-flex align-items-center justify-content-between w-100">
          <Navbar.Brand className="me-3 me-sm-4">
            <Link to="/">
              <img src={logo} alt="Prevencor Marília" style={{ height: '45px' }} />
            </Link>
          </Navbar.Brand>

          <div className="text-secondary d-flex align-items-center gap-2">
            <GoLock size={16} className="text-secondary" />
            <span
              className={`text-uppercase fw-light ${styles['text-xs']}`}
              style={{ letterSpacing: '0.2em' }}
            >
              Portal seguro
            </span>
          </div>
        </div>
      </Container>
    </Navbar>
  );
}
